function initializeSwiper() {
  const swiper = new Swiper('.uswiper-container', {
    autoplay: {
      delay: 5000,
    },
    loop: true,
    slidesPerView: 3,
    spaceBetween: 60,
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      679: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
    },
  });
  return swiper;
}


document.addEventListener('DOMContentLoaded', (event) => {
    var coll = document.getElementsByClassName("collapsibleuz");
    for (var i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
            
            var plusMinus = this.querySelector('.plusminus');
            if (plusMinus) {
                plusMinus.classList.toggle('active');
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
const counters = document.querySelectorAll(".u-key-features-percetage");
counters.forEach(counter => {
    let target = +counter.getAttribute("data-target");
    let speed = +counter.getAttribute("data-speed") || 20;
    let count = 0;
    function updateCount() {
    if (count < target) {
        count++;
        counter.textContent = count + '%';
        setTimeout(updateCount, speed);
    } else {
        counter.textContent = target + '%';
    }
    }
    updateCount();
});
})
